import React, { useState } from "react";

export default function Filter({
  coach_name,
  rating,
  round_rating,
  filterPrograms,
}) {
  const [keyword, setKeyword] = useState("");

  const filterList = (value) => {
    setKeyword(value);
    filterPrograms(value);
  };

  rating = parseFloat(rating).toFixed(1);

  return (
    <div className="row flex-row">
      <div className="col-md-6 col-xs-12 mb20">
        <div className="ibox-content top-blue-line filter-widget">
          <div className="title">Search</div>
          <input
            type="text"
            className="form-control input-search"
            placeholder="Type First or Last Name here"
            value={keyword}
            onChange={(e) => filterList(e.target.value)}
          />
        </div>
      </div>
      <div className="col-md-6 col-xs-12 mb20">
        <div className="ibox-content top-green-line filter-widget">
          <div className="title">Coach Rating</div>
          <div className="green bold font-20">{coach_name}</div>
          <div className="rating">
            <span className="bold font-18">{rating}</span>
            <span className="stars">
              {[...Array(5)].map((value, index) => (
                <i
                  key={`start-${index}`}
                  className={`fa fa-lg fa-star ${
                    round_rating >= index + 1 ? "active" : ""
                  }`}
                ></i>
              ))}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}
